import type { ReactNode } from "react";
import { Box, Container } from "@mui/material";

// and more dark colors
type BgColor = 'primary.main' | 'secondary.main' | null;

interface Props {
  containerProps?: {
    backgroundColor?: BgColor;
    maxWidth?: 'md' | 'lg' | 'xl' | 'full' | null;
    marginBottom: number | null;
    marginTop: number | null;
    paddingBottom: number | null;
    paddingTop: number | null;
  }
  children?: ReactNode;
}

export function ContentRendererContainer({ containerProps, children }: Props) {
  const {
    backgroundColor,
    maxWidth,
    marginBottom,
    marginTop,
    paddingBottom,
    paddingTop,
  } = containerProps || {};

  const renderContent = () => (
    <Container
      maxWidth={maxWidth === 'full' ? false : maxWidth || 'lg'}
    >
      {children}
    </Container>
  )

  if (backgroundColor || marginBottom || marginTop || paddingBottom || paddingTop) {
    return (
      <Box sx={{
        backgroundColor,
        // backgroundColor is supposed to be dark, so text color goes white
        color: backgroundColor ? 'common.white' : undefined,
        mb: marginBottom,
        mt: marginTop,
        pb: paddingBottom,
        pt: paddingTop,
      }}>
        {renderContent()}
      </Box>
    )
  }

  return renderContent()
}
